import axios from '../../../axios';
import IWorkAssignmentsDTOWrapper from '../types/IWorkAssignmentsDTOWrapper';

const url = '/jobsearch/api/work-assignments';
const hiringUrl = '/api/work-assignments';

export const getAssignedTeamsByJobId = (jobId: string) =>
  axios.get(`${url}/assigned-teams-by-jobId?jobId=${jobId}`);

export const getWorkAssignmentsByRecruiterAndJobId = (jobId: string, recruiterEmail: string) =>
  axios.get(`${url}/assignment-by-recruiter-and-job-id/${recruiterEmail}/${jobId}`);

export const save = (assignments: IWorkAssignmentsDTOWrapper) =>
  axios.post(`${hiringUrl}`, assignments);

export const closeWorkAssignments = (workAssignmentsDTOWrapper: IWorkAssignmentsDTOWrapper) =>
  axios.put(`${url}/closelist`, workAssignmentsDTOWrapper);

export const getWorkAssignmentByCurrentRecruiterAndJob = (jobId: string) =>
  axios.get(`${url}/current-recruiter-and-job-id?jobId=${jobId}`);

export const acceptWorkAssignment = (workAssignmentId: string, teamOrRecruiterId: string) =>
  axios.put(`${url}/accept/${workAssignmentId}/${teamOrRecruiterId}`);

export const getWorkAssignmentsByJobId = (jobId: string) =>
  axios.get(`${url}/get-teams-and-recruiters-by-job-id/${jobId}`);

export const getWorkAssignmentsByRecruiterJobMappingId = (JobMappingID: string) =>
  axios.get(`${url}/${JobMappingID}`);
